import React from "react";
import AllTaxiTableDashComp from "../../components/AllTaxiTableDashComp/AllTaxITableDashComp";
import { Link } from "react-router-dom"; // ✅ הוספת הייבוא

function AllTaxiTable() {
  return (
    <div>
      <div className="ButtonToDash-Button">
        <Link to="/dashboard">
          <button className="ButtonToDashbord">מעבר לדשבורד</button>
        </Link>
      </div>
      <h1>טבלת מוניות באתר</h1>
      <AllTaxiTableDashComp />
    </div>
  );
}

export default AllTaxiTable;
